import { MINIMIZE, AFTER_ACTIONS, CLOSE_CHAT_CONFIRMATION, RATING } from "../mutation-types";
import { log2 } from "../../utils/log2";
import { sendSocketMessage } from "../../utils/socketStream";

const log = log2("app.vuex");
const state = {
    videoEnabled: true,
    micEnabled: true,
    remoteVideoEnabled: true,
    remoteMicEnabled: true,
    isSoundOnly: false,
    isScreenOnly: false,
};

const getters = {};

const mutations = {
    ["SET_VIDEO_ENABLED"](state, payload) {
        state.videoEnabled = payload;
    },
    ["SET_MIC_ENABLED"](state, payload) {
        state.micEnabled = payload;
    },
    ["SET_REMOTE_VIDEO_ENABLED"](state, payload) {
        state.remoteVideoEnabled = payload;
    },
    ["SET_REMOTE_MIC_ENABLED"](state, payload) {
        state.remoteMicEnabled = payload;
    },
    ["SET_SOUND_ONLY"](state, payload) {
        state.isSoundOnly = payload;
    },
    ["SET_SCREEN_ONLY"](state, payload) {
        state.isScreenOnly = payload;
    },
};

const actions = {
    setVideoEnabled({ commit, state, rootState }, payload) {
        if (!state.isSoundOnly) {
            commit("SET_VIDEO_ENABLED", payload);
            if (rootState.app.currentVC) {
                sendSocketMessage("visitor video-call-toggle", {
                    siteId: rootState.site.site._id,
                    visitorId: rootState.chat.visitorId,
                    userId: rootState.app.currentVC,
                    mic: state.micEnabled,
                    video: payload,
                    conversationId: rootState.chat.conversationId,
                });
            }
        }
    },
    setMicEnabled({ commit, state, rootState }, payload) {
        commit("SET_MIC_ENABLED", payload);
        if (rootState.app.currentVC) {
            sendSocketMessage("visitor video-call-toggle", {
                siteId: rootState.site.site._id,
                mic: payload,
                video: state.videoEnabled,
                conversationId: rootState.chat.conversationId,
            });
        }
    },
    closeConnection({ commit }) {
        commit("SET_SOUND_ONLY", false);
        commit("SET_REMOTE_VIDEO_ENABLED", true);
        commit("SET_VIDEO_ENABLED", true);
        commit("SET_MIC_ENABLED", true);
        commit("SET_REMOTE_MIC_ENABLED", true);
        commit("app/SET_VC_DIALING", null, { root: true });
    },
    setSoundOnly({ commit }, payload) {
        commit("SET_SOUND_ONLY", payload);
    },
    setScreenOnly({ commit }, payload) {
        commit("SET_SCREEN_ONLY");
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/webrtc.js